module.exports = __webpack_public_path__ + "quilt1-level5.938fb80f.png";